<template>
  <div class="s-service">
    <div class="wrap">
      <span class="title">自助服务</span>
      <ul class="ul-cls">
        <li>
          <a href="https://passport.nxin.com/" target="_blank">
            <svg-icon class="icon" icon-name="retrieve-password"/>
            <p>找回密码</p>
          </a>
        </li>
        <li>
          <a href="http://wo.nxin.com/safe/modify-password" target="_blank">
            <svg-icon class="icon" icon-name="change-phone"/>
            <p>修改手机号</p>
          </a>
        </li>
        <li>
          <a href="http://wo.nxin.com/edit" target="_blank">
            <svg-icon class="icon" icon-name="change-personal-info"/>
            <p>修改个人信息</p>
          </a>
        </li>
        <!--<li>-->
          <!--<a href="https://jr.nxin.com/front/member/initRealName.shtml" target="_blank">-->
            <!--<svg-icon class="icon" icon-name="real-name-authentication"/>-->
            <!--<p>个人实名认证</p>-->
          <!--</a>-->
        <!--</li>-->
        <li>
          <a href="http://wo.nxin.com/ent" target="_blank">
            <svg-icon class="icon" icon-name="enterprise-certification"/>
            <p>注册/认证企业</p>
          </a>
        </li>
        <li>
          <a href="https://sc.nxin.com/mj/toShopCheck" target="_blank">
            <svg-icon class="icon" icon-name="shop-enter"/>
            <p>商城入驻</p>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  @import './style.scss';
</style>

<script>
export default {
  data() {
    return {};
  },
  created() {},
};
</script>
